export default "__VITE_ASSET__c618672c__"